export default __webpack_public_path__ + "static/media/nft-group.f0dd1f91.png";